export default __webpack_public_path__ + "static/media/bbg.12513619.png";